import React from 'react';
import './CTAButton.css';

type Variant = 'gold' | 'blue' | 'outline-dark' | 'outline-light' | 'ghost';
type Size = 'sm' | 'md' | 'lg';

interface BaseProps {
  variant?: Variant;
  size?: Size;
  className?: string;
  children: React.ReactNode;
}

interface ButtonProps extends BaseProps {
  as?: 'button';
  type?: 'button' | 'submit';
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  ariaLabel?: string;
}

interface AnchorProps extends BaseProps {
  as: 'a';
  href: string;
  target?: string;
  rel?: string;
  ariaLabel?: string;
}

type Props = ButtonProps | AnchorProps;

const CTAButton: React.FC<Props> = (props) => {
  const { variant = 'blue', size = 'md', className = '', children } = props;
  const classes =
    `cta-btn cta-btn--${variant} cta-btn--${size} ${className}`.trim();

  if (props.as === 'a') {
    return (
      <a
        href={props.href}
        target={props.target}
        rel={props.rel}
        aria-label={props.ariaLabel}
        className={classes}
      >
        {children}
      </a>
    );
  }

  return (
    <button
      type={props.type ?? 'button'}
      onClick={props.onClick}
      disabled={props.disabled}
      aria-label={props.ariaLabel}
      className={classes}
    >
      {children}
    </button>
  );
};

export default CTAButton;
